import MyTripsCard from "./MyTripsCard";

export default MyTripsCard;